import { normalizeStyleOptions, StyleOptions } from 'botframework-webchat-api';

import createActivitiesStyle from '/druid/StyleSet/Activities';
import createAudioAttachmentStyle from '/druid/StyleSet/AudioAttachment';
import createAudioContentStyle from '/druid/StyleSet/AudioContent';
import createAutoResizeTextAreaStyle from '/druid/StyleSet/AutoResizeTextArea';
import createAvatarStyle from '/druid/StyleSet/Avatar';
import createBasicTranscriptStyle from '/druid/StyleSet/BasicTranscript';
import createBubbleStyle from '/druid/StyleSet/Bubble';
import createCarouselFilmStrip from '/druid/StyleSet/CarouselFilmStrip';
import createCarouselFilmStripAttachment from '/druid/StyleSet/CarouselFilmStripAttachment';
import createCarouselFlipper from '/druid/StyleSet/CarouselFlipper';
import createConnectivityNotification from '/druid/StyleSet/ConnectivityNotification';
import createDictationInterimsStyle from '/druid/StyleSet/DictationInterims';
import createErrorBoxStyle from '/druid/StyleSet/ErrorBox';
import createErrorNotificationStyle from '/druid/StyleSet/ErrorNotification';
import createFileContentStyle from '/druid/StyleSet/FileContent';
import createImageAvatarStyle from '/druid/StyleSet/ImageAvatar';
import createInitialsAvatarStyle from '/druid/StyleSet/InitialsAvatar';
import createKeyboardHelpStyle from '/druid/StyleSet/KeyboardHelp';
import createMicrophoneButtonStyle from '/druid/StyleSet/MicrophoneButton';
import createRootStyle from '/druid/StyleSet/Root';
import createScrollToEndButtonStyle from '/druid/StyleSet/ScrollToEndButton';
import createSendBoxButtonStyle from '/druid/StyleSet/SendBoxButton';
import createSendBoxStyle from '/druid/StyleSet/SendBox';
import createSendBoxTextBoxStyle from '/druid/StyleSet/SendBoxTextBox';
import createSendStatusStyle from '/druid/StyleSet/SendStatus';
import createSingleAttachmentActivityStyle from '/druid/StyleSet/SingleAttachmentActivity';
import createSpinnerAnimationStyle from '/druid/StyleSet/SpinnerAnimation';
import createStackedLayoutStyle from '/druid/StyleSet/StackedLayout';
import createSuggestedActionsStyle from '/druid/StyleSet/SuggestedActions';
import createSuggestedActionStyle from '/druid/StyleSet/SuggestedAction';
import createTextContentStyle from '/druid/StyleSet/TextContent';
import createToasterStyle from '/druid/StyleSet/Toaster';
import createToastStyle from '/druid/StyleSet/Toast';
import createTypingAnimationStyle from '/druid/StyleSet/TypingAnimation';
import createTypingIndicatorStyle from '/druid/StyleSet/TypingIndicator';
import createUploadButtonStyle from '/druid/StyleSet/UploadButton';
import createVideoAttachmentStyle from '/druid/StyleSet/VideoAttachment';
import createVideoContentStyle from '/druid/StyleSet/VideoContent';
import createVimeoContentStyle from '/druid/StyleSet/VimeoContent';
import createWarningNotificationStyle from '/druid/StyleSet/WarningNotification';
import createYouTubeContentStyle from '/druid/StyleSet/YouTubeContent';

// TODO: [P4] We should add a notice for people who want to use "styleSet" instead of "styleOptions".
//       "styleSet" is actually CSS stylesheet and it is based on the DOM tree.
//       DOM tree may change from time to time, thus, maintaining "styleSet" becomes a constant effort.

export default function createStyleSet(styleOptions: StyleOptions) {
  const strictStyleOptions = normalizeStyleOptions(styleOptions);

  return {
    activities: createActivitiesStyle(),
    audioAttachment: createAudioAttachmentStyle(strictStyleOptions),
    audioContent: createAudioContentStyle(),
    autoResizeTextArea: createAutoResizeTextAreaStyle(strictStyleOptions),
    avatar: createAvatarStyle(strictStyleOptions),
    basicTranscript: createBasicTranscriptStyle(strictStyleOptions),
    bubble: createBubbleStyle(strictStyleOptions),
    carouselFilmStrip: createCarouselFilmStrip(strictStyleOptions),
    carouselFilmStripAttachment: createCarouselFilmStripAttachment(strictStyleOptions),
    carouselFlipper: createCarouselFlipper(strictStyleOptions),
    connectivityNotification: createConnectivityNotification(strictStyleOptions),
    dictationInterims: createDictationInterimsStyle(strictStyleOptions),
    errorBox: createErrorBoxStyle(strictStyleOptions),
    errorNotification: createErrorNotificationStyle(strictStyleOptions),
    fileContent: createFileContentStyle(strictStyleOptions),
    imageAvatar: createImageAvatarStyle(strictStyleOptions),
    initialsAvatar: createInitialsAvatarStyle(strictStyleOptions),
    keyboardHelp: createKeyboardHelpStyle(strictStyleOptions),
    microphoneButton: createMicrophoneButtonStyle(strictStyleOptions),
    options: { ...strictStyleOptions }, // Cloned to make sure no additional modifications will propagate up.
    root: createRootStyle(strictStyleOptions),
    scrollToEndButton: createScrollToEndButtonStyle(strictStyleOptions),
    sendBox: createSendBoxStyle(strictStyleOptions),
    sendBoxButton: createSendBoxButtonStyle(strictStyleOptions),
    sendBoxTextBox: createSendBoxTextBoxStyle(strictStyleOptions),
    sendStatus: createSendStatusStyle(strictStyleOptions),
    singleAttachmentActivity: createSingleAttachmentActivityStyle(strictStyleOptions),
    spinnerAnimation: createSpinnerAnimationStyle(strictStyleOptions),
    stackedLayout: createStackedLayoutStyle(strictStyleOptions),
    suggestedAction: createSuggestedActionStyle(strictStyleOptions),
    suggestedActions: createSuggestedActionsStyle(strictStyleOptions),
    textContent: createTextContentStyle(strictStyleOptions),
    toast: createToastStyle(strictStyleOptions),
    toaster: createToasterStyle(strictStyleOptions),
    typingAnimation: createTypingAnimationStyle(strictStyleOptions),
    typingIndicator: createTypingIndicatorStyle(strictStyleOptions),
    uploadButton: createUploadButtonStyle(strictStyleOptions),
    videoAttachment: createVideoAttachmentStyle(),
    videoContent: createVideoContentStyle(strictStyleOptions),
    vimeoContent: createVimeoContentStyle(strictStyleOptions),
    warningNotification: createWarningNotificationStyle(strictStyleOptions),
    youTubeContent: createYouTubeContentStyle(strictStyleOptions)
  };
}
